import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { api, AssetLocation, AssetLocationTypes, AssetType, IKeyManagerAuditsAtLocation, IKeyManagerAuditsDue, KeyAuditType, KeyManagementTypes } from "../../../logic/api";
import styles from "../styles";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import KeyAuditDueListItem from "../../../components/lists/listItems/KeyAuditDue/KeyAuditDueListItem";
import KeyAuditScanner from "../../keys/keyAudit/KeyAuditScanner";
import AuditsDueRow from "./condensedLayout/auditsDue/AuditsDueRow";
import HeaderRow from "./condensedLayout/HeaderRow";
import { useTranslation } from "react-i18next";
import { ReleaseFlag, useReleaseManagement } from "@/utility/feature-management";
import { usePreferences } from "@/utility/usePreferences";

const KeyAuditsDueAtLocation: React.FunctionComponent<{
    isCondensedView?: boolean;
    path: string;
    onSelected?: (location: AssetLocation) => void;
}> = (props) => {
    //const history = useHistory();
    const { t } = useTranslation();

    const [params, setParams] = useState<IKeyManagerAuditsAtLocation>({
        path: props.path
    });
    const [location, setLocation] = useState<AssetLocation | null>(null);
    const [showAuditKeyScanner, setShowAuditKeyScanner] = useState(false);

    const preferences = usePreferences();

    const isKeyAuditDueCriteriaReleased = useReleaseManagement(ReleaseFlag.releaseKeyAuditDueCriteria);

    const enforceKeyPositionAudit = () => {
        if (isKeyAuditDueCriteriaReleased) {
            if (location?.type && [AssetLocationTypes.Keyroom, AssetLocationTypes.KeyBox, AssetLocationTypes.Hook].includes(location?.type)) {
                return false;
            } else {
                return (preferences.enable_enforce_key_position_audit && preferences.keyAuditSettings?.lane.auditType === KeyAuditType.Order)
            }
        } else {
            return preferences.enable_enforce_key_position_audit;
        }
    };

    useEffect(() => {
        if (props.path != params.path) {
            setParams({
                ...params, path: props.path
            });
        }
    }, [props.path]);

    return <div>
        {location != null && (
            <KeyAuditScanner show={showAuditKeyScanner} location={location} enforceKeyPositionAudit={enforceKeyPositionAudit()} onClose={(submitted) => {
                setShowAuditKeyScanner(false);
                if (submitted == true) {
                    setParams({
                        ...params, path: props.path
                    });
                }
            }} />
        )}
        {props.isCondensedView ? (<PagedDataView<IKeyManagerAuditsDue, AssetLocation>
            apiHook={api.hooks.keyManager.getAuditsDue}
            parameters={params}
            header={() => <HeaderRow
                columnHeaders={[t("booking.cards.status"), t("locations.dueDate"), t("locations.location")]} />}
            isTable
            animate={false}
            renderItem={(item, index) => {
                return <AuditsDueRow assetLocation={item} auditCategory={AssetType.vehicleKey} rowIndex={index} onClick={() => {
                    if (props.onSelected != null) {
                        props.onSelected(item);
                    }
                }} />
            }}>
            <div style={styles.noData}>
                {t("locations.noAuditsDue")}
            </div>
        </PagedDataView>)
            :
            (<PagedDataView<IKeyManagerAuditsDue, AssetLocation>
                apiHook={api.hooks.keyManager.getAuditsDue}
                parameters={params}
                renderItem={(item) => {
                    return <KeyAuditDueListItem item={item} onClick={() => {
                        //history.push(paths.booking(item.id));
                        if (props.onSelected != null) {
                            props.onSelected(item);
                        } else {
                            setLocation(item);
                            setShowAuditKeyScanner(true);
                        }

                    }} />
                }}
            >
                <div style={styles.noData}>
                    {t("locations.noAuditsDue")}
                </div>
            </PagedDataView>
            )}
    </div>;
};

KeyAuditsDueAtLocation.propTypes = {
    path: propTypes.string.isRequired,
    onSelected: propTypes.func
}

export default KeyAuditsDueAtLocation;
